import { createFileRoute, notFound } from "@tanstack/react-router";
import { PortalNotFound } from "@/components/PortalNotFound";
import { pageHead } from "@/lib/routeHead";
export const Route = createFileRoute("/partner/$")({
  head: () =>
    pageHead(
      "Partner Page Not Found",
      "This Partner workspace page does not exist.",
      "/partner",
      true,
    ),
  beforeLoad: () => {
    throw notFound();
  },
  notFoundComponent: PortalNotFound,
});
